import React from 'react';
import { X } from 'lucide-react';

interface AttachmentModalProps {
  fileUrl: string;
  fileName: string;
  onClose: () => void;
}

export default function AttachmentModal({ fileUrl, fileName, onClose }: AttachmentModalProps) {
  const isPDF = fileName.toLowerCase().endsWith('.pdf');

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl max-h-[90vh] w-full mx-4 overflow-hidden">
        <div className="p-4 border-b border-gray-200 flex items-center justify-between">
          <h3 className="font-semibold text-lg">{fileName}</h3>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X size={20} className="text-gray-600" />
          </button>
        </div>
        
        <div className="p-4 flex items-center justify-center max-h-[calc(90vh-8rem)] overflow-auto">
          {isPDF ? (
            <iframe
              src={fileUrl}
              className="w-full h-[80vh]"
              title={fileName}
            />
          ) : (
            <img
              src={fileUrl}
              alt={fileName}
              className="max-w-full max-h-full object-contain"
            />
          )}
        </div>
      </div>
    </div>
  );
}
